import React from 'react';
import './index.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate
} from 'react-router-dom';
// All pages
import Home from './pages/Home';
import Contact from './pages/Contact';
import DemoProduct from './pages/DemoProduct';
import About from './pages/About';
import ZuyuApp from './pages/ZuyuApp';
import NewsList from './pages/NewsList';
import NewsDetail from './pages/NewsDetail';

import ScrollToTop from './components/ScrollToTop';
import BackToTop from './components/BackToTop';
import TransferPage from './pages/TransferPage';
import AppLanding from './pages/AppLanding';

function App() {
  // 不在这里设 title：父组件 useEffect 会覆盖子页面标题
  // 默认标题见 public/index.html；各页面自行 useDocTitle

  return (
    <>
      <Router>
        <ScrollToTop>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Navigate to="/" replace />} />
            <Route path="/about" element={<About />} />
            <Route path="/app" element={<ZuyuApp />} />
            <Route path="/news" element={<NewsList />} />
            <Route path="/news/:slug" element={<NewsDetail />} />
            <Route path="/download" element={<AppLanding />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/get-demo" element={<DemoProduct />} />
            <Route path="/zuyu-app" element={<TransferPage />} />
          </Routes>
          <BackToTop />
        </ScrollToTop>
      </Router>
    </>
  );
}


export default App;
